// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogLayout_container__3qFSC","title":"BlogLayout_title__1nCOk","logo":"BlogLayout_logo__30fIK"};